import {useState} from 'react'
import styled from 'styled-components'
import Select from 'react-select-me'
import DownArrowIcon from '@/components/icons/DownArrowIcon'
import {motion} from 'framer-motion'

const Dropdown = styled.div<{ colors?: string[] }>`
    background: rgba(${props => props.colors?.[0]}, 0.1);
    display: flex;
    align-items: center;
    height: 37px;
    width: 100%;
    position: relative;
    border: 1px solid #3E455A;
    border-radius: 5px;
    margin-top: -10px;
    font-family: proxima nova;
    font-size: 14px;
    font-weight: 600;

    .dd__wrapper {
        width: 100%;
        position: absolute;

        .dd__selectControl {
            background: transparent;
            border: none;
            padding: 0px 8px;
        }
    }

    .dd__placeholder {
        color: #fff;
        font-size: 14px;
        text-indent: 2px;
    }

    .dd__selectedItem {
        color: #fff;
        font-size: 14px;
        text-indent: 2px;
    }

    .dd__list {
        background: rgba(35, 40, 54, 1.0);
        border-radius: 0;
        border: 1px solid #3E455A;
        border-radius: 5px;
        margin-top: 4px;
        position: absolute;
        top: 27px;
        margin-left: -1px;
        width: calc(100% + 2px);
        z-index: 1000;

        .dd__option:active,
        .dd__option:hover {
            background: rgba(155, 163, 176, 0.15);
            color: rgba(155, 163, 176, 1.0);
        }

        .dd__option {
            color: rgba(155, 163, 176, 1.0);
            text-indent: 10px;
            font-size: 12px;
            height: 38px;
            display: flex;
            align-items: center;
        }

        .dd__selectedOption {
            background: rgba(35, 40, 54, 1.0);
            color: #fff;
        }
    }
`

const DropdownLabel = styled.div`
    width: 90%;
    font-size: 10px;
    text-align: center;
`

const DropdownButton = styled.a<{ colors?: string[] }>`
    width: 25px;
    height: 100%;
    color: rgba(${props => props.colors?.[0]}, 1);
    display: flex;
    align-items: center;

    &:active {
        background: rgba(${props => props.colors?.[0]}, 0.2);
    }

    div {
        width: 100%;
        text-align: center;
    }

    svg {
        width: 50%;
        height: 50%;
        margin: 0 auto;
    }
`

const theme = {color: {primary: 'rgba(255, 255, 255, 0.801)', primaryHighlight: 'rgba(255, 255, 255, 1)'}}

interface VariantResolution {
	value: string | number
	label: string
}

interface VariantSelectProps {
	variantResolutions: VariantResolution[]
	selectedVariant: string | number
	setVariantShard: (...args: any[]) => void
	parentShardId: string | number
	setVariantDropdownZIndex: (zIndex: number) => void
}

const VariantSelect = ({
	                       variantResolutions,
	                       selectedVariant,
	                       setVariantShard,
	                       parentShardId,
	                       setVariantDropdownZIndex
                       }: VariantSelectProps) => {
	const [isOpen, setIsOpen] = useState(false)
	const [variantShardId, setVariantShardId] = useState<string | number | null>(selectedVariant || null)

	const setIsOpenMiddleware = (value: boolean) => {
		setIsOpen(value)
		value ? setVariantDropdownZIndex(2000) : setVariantDropdownZIndex(2)
	}

	return (
		<Dropdown className='Dropdown' colors={[theme.color.primary, theme.color.primaryHighlight]}>
			<DropdownLabel/>
			<DropdownButton colors={[theme.color.primary]}>
				{/* @ts-ignore */}
				<motion.div
					marginLeft="-4px"
					animate={isOpen ? {rotate: 180} : {rotate: 0}}
					transition={{ease: 'easeInOut', duration: 0.3}}
				>
					<DownArrowIcon/>
				</motion.div>
			</DropdownButton>
			<Select
				options={variantResolutions}
				iconRenderer={() => null}
				onOpen={() => setIsOpenMiddleware(true)}
				onClose={() => setIsOpenMiddleware(false)}
				value={variantShardId || selectedVariant || variantResolutions[0].value}
				onChange={(value: VariantResolution) => {
					setVariantShard(parentShardId, value.value)
					setVariantShardId(value.value)
				}}
			/>
		</Dropdown>
	)
}

export default VariantSelect
